import { useEffect, useRef,useState } from 'react';

import PrivacyPolicyIcon from '@/assets/all-icons/privacy-policies-icon';
import FormError from '@/shared-components/error/components/FormError';
import CreateArtist from '@/shared-components/forms/create-artist';
import InfoIconArtwork from '@/shared-components/icons/components/public/InfoIconArtwork';
import PublicSuccessCheck from '@/shared-components/icons/components/public/PublicSuccessCheck';
import Text from '@/shared-components/text/components/Text';

import CompleteArtist from './components/CompleteArtist';
import Suggestions from './suggestions';

import './index.css';

export default function SearchArtist({
  error,
  element,
  typeOfArtwork,
  value,
  onChange,
  infoIcon,
  disabled = false,
  className = '',
}) {
  const [openCreateArtist, setOpenCreateArtist] = useState(false);
  const [artistToComplete, setArtistToComplete] = useState(null);
  const [openSuggestions, setOpenSuggestions] = useState(false);
  const [query, setQuery] = useState({ user_name: "" });
  const searchContainer = useRef();
  const artistInputRef = useRef();
  const [isInfoIconOpen, setIsInfoIconOpen] = useState(false);

  const getArtistDisplayName = (artist) => {
    if (!artist) return "";
    return artist.gallery_artist
      ? artist.user_name
      : (artist.artist_name || artist.user_name || artist.user_username || "");
  };

  useEffect(()=>{
    if(typeOfArtwork === "Work of Artist" && Boolean(value) && value.artist_should_request_email) {
      setArtistToComplete(value);
    }
  }, [typeOfArtwork]);

  useEffect(() => {
    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (!artistInputRef.current) return;
    const displayName = getArtistDisplayName(value);
    if (artistInputRef.current.value !== displayName) {
      artistInputRef.current.value = displayName;
    }
  }, [value]);

  function handleClickOutside(e) {
    if(!searchContainer.current.contains(e.target)) {
      setOpenSuggestions(false);
    }
  }

  function selectArtist(artist) {
    onChange(artist);
    artistInputRef.current.value = getArtistDisplayName(artist);
  }

  function handleSelectArtist(artist) {
    setOpenSuggestions(false);

    if(Boolean(artist.gallery_artist) || !artist.artist_should_request_email || typeOfArtwork === "Gallery owned") {
      selectArtist(artist);
    } else {
      setArtistToComplete(artist);
    }
  }

  function handleArtistSuggestions() { 
    const searchQuery = artistInputRef.current.value;

    if(searchQuery !== value?.artist_name && searchQuery !== value?.user_name && searchQuery !== value?.user_username) {
      onChange(null);
    }
        
    if (searchQuery.length > 1) {
      setOpenSuggestions(true);
      setQuery({ user_name: searchQuery });
    } else {
      setOpenSuggestions(false);
    }
  }

  return (
    <>
      <div
        className={`add-artwork__search-artist-container ${disabled ? 'is-disabled' : ''} ${className}`.trim()}
        ref={searchContainer}
      >
        <div className={`dropdown dropdown--form add-artwork__search-artist-search-bar ${openSuggestions ? "active is-open" : ""}`} id={`${element}_error`}>
          <div className="dropdown__trigger add-artwork__search-artist-search-bar-trigger">
            <div className="dropdown__text-container">
              <label htmlFor={`${element}_visible`} className="dropdown__label add-artwork__search-artist-search-bar-label">
                <Text className="add-artwork__search-artist-search-bar-label-text">
                              Artist
                </Text>
                <InfoIconArtwork
                  className="step-accordeon-step-header__info-icon"
                  onClick={(status) => setIsInfoIconOpen(status)}
                  open={isInfoIconOpen}
                  header={infoIcon.header || infoIcon.name}
                  description={infoIcon.description}
                />
              </label>

              <div className="dropdown__value-row add-artwork__search-artist-search-bar-container">
                <input
                  type="text"
                  className="dropdown__value add-artwork__search-artist-search-bar-input"
                  id={`${element}_visible`}
                  name={`${element}_visible`}
                  spellCheck={false}
                  defaultValue={getArtistDisplayName(value)}
                  autoComplete="off"
                  readOnly={disabled}
                  disabled={disabled}
                  onFocus={handleArtistSuggestions}
                  onChange={handleArtistSuggestions}
                  ref={artistInputRef}
                />

                {
                  disabled
                  // Si estoy en modo disabled, muestro el icono de policy
                    ? <PrivacyPolicyIcon
                      className="add-artwork-search-artist__artist-selected-check"
                    />
                  // Si no, y hay value, muestro el check
                    : value && (
                      <PublicSuccessCheck
                        className="add-artwork-search-artist__artist-selected-check"
                      />
                    )
                }
              </div>
            </div>
          </div>
        </div>

        {openSuggestions && !disabled && (
          <Suggestions 
            query={query} 
            currentArtist={value} 
            selectArtist={handleSelectArtist} 
            openArtistForm={()=>{setOpenCreateArtist(true); setOpenSuggestions(false);}} 
          />
        )}  

        <FormError 
          error={error} 
          alternativeElement={`${element}_error`} 
          errorClassName="public-form-input__input-error" 
          element={element}
        /> 
      </div>
      <CreateArtist 
        open={openCreateArtist} 
        close={()=>setOpenCreateArtist(false)}
        onCreate={selectArtist} 
        createMode={typeOfArtwork}
      />
      <CompleteArtist
        open={Boolean(artistToComplete)}
        close={()=>setArtistToComplete(null)} 
        onClose={() => {
          onChange(null); 
          artistInputRef.current.value = "";
        }}
        artistToComplete={artistToComplete}
        onComplete={selectArtist}
      />
    </>
  );
}
